<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-cogs text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Layouts de Importação</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Configuração de mapeamento para XML/TXT de fornecedores</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 mr-2">
                    <b-form-input v-model="filtro.descricao" placeholder="Buscar por descrição..." class="border-0 bg-transparent" style="width: 250px" @keydown.enter.native="pesquisar()"></b-form-input>
                </div>
                <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button ref="btAdicionar" variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Novo Layout</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="6">
                      <cliente-pesquisa 
                        @retornaId="filtro.fornecedorId = $event"
                        :idInicial="filtro.fornecedorId"
                        label="Fornecedor"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="fornecedorpesquisa"
                        idModal="fornecedorpesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Tipo de Arquivo</label>
                      <b-form-select v-model="filtro.tipoArquivo" :options="optionsTipoArquivo" class="rounded-pill bg-light border-0 shadow-xs px-3"></b-form-select>
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Status</label>
                      <b-form-select v-model="filtro.ativo" :options="optionsStatus" class="rounded-pill bg-light border-0 shadow-xs px-3"></b-form-select>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!-- Table Section -->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table
            ref="tblLayouts"
            :items="itens"
            :fields="fields"
            :busy="isBusy"
            hover
            responsive
            striped
            show-empty
            empty-text="Nenhum layout encontrado."
            class="table-premium shadow-sm rounded-lg"
            thead-class="bg-light text-uppercase small font-weight-bold"
            @row-dblclicked="edit"
          >
            
            <template #cell(TIPO_ARQUIVO)="row">
                <b-badge :variant="row.item.TIPO_ARQUIVO === 'XML' ? 'info' : 'secondary'" pill class="px-3">
                    {{ row.item.TIPO_ARQUIVO }}
                </b-badge>
            </template>

            <template #cell(ATIVO)="row">
                <b-badge :variant="row.item.ATIVO === 'S' ? 'success' : 'danger'" pill class="px-3">
                    {{ row.item.ATIVO === 'S' ? 'ATIVO' : 'INATIVO' }}
                </b-badge>
            </template>

            <template #cell(actions)="row">
                <div class="d-flex justify-content-center gap-2">
                    <b-button variant="soft-primary" size="sm" class="rounded-circle mr-1" @click="edit(row.item)" v-b-tooltip.hover title="Editar">
                        <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button variant="soft-danger" size="sm" class="rounded-circle" @click="excluir(row.item)" v-b-tooltip.hover title="Excluir">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </div>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center p-3" v-if="totalRows > perPage">
        <div class="small text-muted">
            Mostrando {{ ((currentPage - 1) * perPage) + 1 }} a {{ Math.min(currentPage * perPage, totalRows) }} de {{ totalRows }} registros
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="right"
          size="sm"
          class="my-0 modern-pagination"
        ></b-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import Tools from '@/tools/tools.js'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'

export default {
  name: 'LayoutImportacaoListagem',
  components: {
    ClientePesquisa
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'itens',
    tblRef: 'tblLayouts',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'NOME_FORNECEDOR', type: 'string', label: 'Fornecedor' },
      { key: 'TIPO_ARQUIVO', type: 'string', label: 'Tipo' },
      { key: 'ATIVO', type: 'string', label: 'Status', labelMap: { 'S': 'Ativo', 'N': 'Inativo' } }
    ]
  })],
  data() {
    return {
      isBusy: false,
      currentPage: 1,
      totalRows: 0,
      itens: [],
      filtro: {
        descricao: '',
        fornecedorId: null,
        tipoArquivo: '',
        ativo: '',
        avancado: false
      },
      fields: [
        { key: 'ID', label: 'ID', sortable: true, thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '80px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true },
        { key: 'NOME_FORNECEDOR', label: 'Fornecedor', sortable: true },
        { key: 'TIPO_ARQUIVO', label: 'Tipo', sortable: true, thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '100px' } },
        { key: 'ATIVO', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '100px' } },
        { key: 'actions', label: 'Ações', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '120px' } }
      ],
      optionsTipoArquivo: [
        { value: '', text: 'Todos' },
        { value: 'XML', text: 'XML' },
        { value: 'TXT', text: 'TXT' }
      ],
      optionsStatus: [
        { value: '', text: 'Todos' },
        { value: 'S', text: 'Ativos' },
        { value: 'N', text: 'Inativos' }
      ]
    }
  },
  computed: {
    isDark() {
      return this.$store.state.controle.isDark
    }
  },
  methods: {
    async pesquisar() {
      this.isBusy = true
      try {
        const payload = {
          descricao: this.filtro.descricao,
          fornecedorId: this.filtro.fornecedorId,
          tipoArquivo: this.filtro.tipoArquivo,
          ativo: this.filtro.ativo
        }
        const { data } = await this.$http.post('/api/protected/layout-importacao/pesquisar', payload)
        this.itens = data
        this.totalRows = data.length
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao buscar layouts')
      } finally {
        this.isBusy = false
      }
    },
    novo() {
      this.$router.push('/cadastros/layout-importacao/add')
    },
    edit(item) {
      this.$router.push(`/cadastros/layout-importacao/edit/${item.ID}`)
    },
    async excluir(item) {
      const confirm = await this.$bvModal.msgBoxConfirm(`Deseja realmente excluir o layout "${item.DESCRICAO}"?`, {
        title: 'Confirmação',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })

      if (confirm) {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.delete(`/api/protected/layout-importacao/delete/${item.ID}`)
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Layout excluído com sucesso')
          this.pesquisar()
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Falha ao excluir layout')
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    limpar() {
      this.filtro.descricao = ''
      this.filtro.fornecedorId = null
      this.filtro.tipoArquivo = ''
      this.filtro.ativo = ''
      if (this.$refs.fornecedorpesquisa) {
        this.$refs.fornecedorpesquisa.onClear()
      }
      this.pesquisar()
    },
    exportarExcel() {
       // Mock or implement actual excel export if needed
       Tools.exibirMensagem(this.$store, 'Info', 'info', 'Exportação em desenvolvimento')
    }
  },
  mounted() {
    this.pesquisar()
  }
}
</script>

<style scoped>
.list-header-premium {
  border-radius: 15px;
  background: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 20px;
}

.search-pill-responsive {
  transition: all 0.3s ease;
}

.search-pill-responsive:focus-within {
  box-shadow: 0 0 0 3px rgba(32, 168, 216, 0.15) !important;
  border-color: #20a8d8 !important;
}

.card-filter-premium {
  background: #f8f9fa;
  border-radius: 15px;
}

.custom-input-premium {
  border-radius: 10px;
  border: 1px solid #e9ecef;
  padding: 0.6rem 1rem;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/layout-importacao/LayoutImportacaoListagem.vue